import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { ModuleUrls, WebsiteMenu } from "../interfaces/websiteData.interface";

const initialState: {
  data: any;
  websiteMenu: WebsiteMenu[];
  moduleUrls: ModuleUrls | undefined;
} = {
  data: null,
  websiteMenu: [],
  moduleUrls: undefined,
};
export const siteSlice = createSlice({
  name: "site",
  initialState,
  reducers: {
    setSiteData: (state, action: PayloadAction<any>) => {
      localStorage.setItem("siteData", JSON.stringify(action.payload));
      state.data = action.payload;
    },
    setWebsiteMenu: (state, action: PayloadAction<any>) => {
      state.websiteMenu = action.payload;
    },
    setModuleUrls: (state, action: PayloadAction<ModuleUrls>) => {
      state.moduleUrls = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSiteData, setModuleUrls, setWebsiteMenu } = siteSlice.actions;

export const selectSiteData = (state: RootState) => state.siteData.data;

export default siteSlice.reducer;
